module.exports = "<div class=\"receiptpos-view-container\">\n    <div>\n        <receipt-image></receipt-image>\n    </div>\n</div>"